export const TerminationTypeFormName = {
  Withdrawal: 'RETRACTATION DE CONTRAT - PARCOURS NON CONNECTE',
  Terminate: 'RESILIATION DE CONTRAT - PARCOURS NON CONNECTE',
  Cancel: 'RENONCIATION DE CONTRAT - PARCOURS NON CONNECTE',
};
